import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { TikTokAuthCallback } from "../../redux/auth/authSlice";
import { GetDecryptEmailformat, GetDecryptReferenceNumberformat } from "../Common/Common";


/**
 * TikTok OAuth callback (S-16, refined U-02).
 *
 * State CSRF defense is applied IF TikTok returned a `state` query param:
 *  - if present, it MUST match `sessionStorage.tiktok_oauth_state`;
 *  - if absent, we log a warning and proceed (the backend should start
 *    generating + echoing `state` for real protection — ops runbook #11).
 *
 * The previous revision unconditionally required the nonce which silently
 * broke the flow since no caller writes it today.
 */
const AuthCallback = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const authCode = queryParams.get("code");
    const returnedState = queryParams.get("state");
    const expectedState = sessionStorage.getItem("tiktok_oauth_state");

    if (!authCode) {
     
      navigate("/");
      return;
    }

    if (returnedState) {
      if (!expectedState || returnedState !== expectedState) {
      
        sessionStorage.removeItem("tiktok_oauth_state");
        navigate("/");
        return;
      }
      sessionStorage.removeItem("tiktok_oauth_state");
    } else {
    }

    const email = GetDecryptEmailformat();
    const reference_number = GetDecryptReferenceNumberformat();
    const userData = { email, reference_number, code: authCode };

    dispatch(TikTokAuthCallback(userData, location));
  }, [dispatch, location, navigate]);

  return <div role="status">Authenticating…</div>;
};

export default AuthCallback;
